import React, { useState } from 'react'
import { withStyles, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { IconButton } from '../default'
import { UpdateISSModal } from '../modal'
import { Edit } from '@material-ui/icons'

const FINANCIAL_CONFIG_MODALS = {
  UPDATE_ISS: 1
}

function CardFinancialConfig({
  classes
}) {
  const { t } = useTranslation()

  const [currentModal, setCurrentModal] = useState(null)

  const loadUpdateIssModal = () => {
    setCurrentModal(FINANCIAL_CONFIG_MODALS.UPDATE_ISS)
  }

  return (
    <div className={classes.form}>
      <UpdateISSModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === FINANCIAL_CONFIG_MODALS.UPDATE_ISS} />
      <Grid container xs={12} md={8} lg={6} xl={4} spacing={1} justifyContent='center'>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadUpdateIssModal}
              icon={Edit}
            >
              {t('cards.financial.config.btnUpdateIss')}
            </IconButton>
          </CardPaper>
        </Grid>
      </Grid>
    </div>
  )
}

const styles = theme => ({
  header: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  formField: {
    width: '100%', 
    height: '100%'
  },
  gridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  }
})

export default withStyles(styles)(CardFinancialConfig)